import Vue from 'vue'
import Router from 'vue-router'
import RouterList from './router'
import VueCookie from 'vue-cookie'
import store from '@/store'
import { base64 } from '../utils/index'
import { Message } from 'element-ui'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: RouterList,
})

//路由器跳转前置操作
router.beforeEach(async (to, from, next) => {
  toPath = to.fullPath
  fromPath = from.fullPath

  const regex = /^\/(register|password_reset|user_agreement|tradePc|tradeWap)/

  //注册和找回密码无需登录 可以直接访问
  if (regex.test(toPath)) {
    return next()
  }

  //注册成功 点击跳转用户中心  免登陆
  if (to.query.token) {
    localStorage.setItem('_token', to.query.token)
    //$cookie.set('remember', '1', { expires: '365D' })
    //存储cookie 自动登录
    let d = new Date()
    d.setTime(d.getTime() + 360 * 24 * 60 * 60 * 1000)
    let expires = 'expires=' + d.toGMTString()
    document.cookie = 'remember=1; ' + expires
    await store.dispatch('getUserInfo', {
      type: 1,
      lastLoginTime: '',
      isSetTypeOrRole: 1,
    })
  }

  //deposit antbag recharge bankremittance  transferPayment lightningPayment
  // if(to.name=='deposit'||to.name=='antbag'||to.name=='recharge'||to.name=='bankremittance'||to.name=='transferPayment'||to.name=='lightningPayment'){
  //   if(!(store.state.userInfo.role==4||store.state.userInfo.role==5)){
  //     Message({
  //       message:"暂无可用通道，请联系客服处理。",
  //       type: 'warning'
  //     });
  //     return
  //   }
  // }
  // 资金管理权限
  if (to.meta.pathWay) {
    let fundsPage = to.meta.pathWay.split('-')[0]
    if (fundsPage == 4 && store.state.listType == 1) {
      store.dispatch('fundsStatus', to.meta.title)
    }
  }

  //window.document.title = to.meta.title
  window.scrollTo(0, 0)

  let auth = to.meta.auth
  let userInfo = localStorage.getItem('I') ? JSON.parse(base64.decode(localStorage.getItem('I'))) : ''
  // let userInfo = userInfo2.jfAccount || userInfo2.jfSimulatorAccount

  if (!VueCookie.get('remember') && to.path != '/login') {
    // Message.error('登录过期，请重新登录')
    if (store.state.userRole == 4 || store.state.userRole == 5 || /www.prowayfx/.test(window.location.origin) || /www.prowayxau/.test(window.location.origin)) {
      let clientid = localStorage.getItem('clientid')
      localStorage.clear()
      localStorage.setItem('clientid', clientid)
      window.location.href = '/login'
    } else {
      let clientid = localStorage.getItem('clientid')
      localStorage.clear()
      localStorage.setItem('clientid', clientid)
      next({
        path: '/login',
        replace: true,
      })
    }

    return
  } else if ((from.name == 'Login' && userInfo.type) || to.name == 'error-403' || to.name == 'error-404' || to.name == 'error-500') {
    next()
  } else if (typeof userInfo.type === 'undefined' && to.path != '/login') {
    if (from.name == 'test') {
      next()
    } else {
      // Message.error('登录过期，请重新登录')
    if (store.state.userRole == 4 || store.state.userRole == 5 || /www.jf24k/.test(window.location.origin) ) {
      window.location.href = '/login'
    } else {
      next({
        path: '/login',
        replace: true,
      })
    }
    }
    
  } else if (typeof userInfo.type != 'undefined' && to.path == '/login') {
    next({
      path: '/home',
      replace: true,
    })
  } else if (typeof userInfo.type != 'undefined' && store.state.accountType == '0' && !auth && to.meta.title != '首页') {
    next({
      path: '/403',
      replace: true,
    })
  } else {
    next()
  }
  maidian({ eventname: 'z1', eventdescribe: '访客数据', eventtype: 'visit' })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js